import React, { useCallback, useEffect, useState } from 'react'
import { Col, Row, Card, Table, Form, Button } from '@themesberg/react-bootstrap'
import { useCookies } from 'react-cookie'
import {
  getAllChargeUsers,
  addChargeUser,
  updateChargeUser,
  updateChargeUserStatus,
  resetChargeUserPassword,
} from '../../../../../controller/api/chargeUser'
import { getAllAdmins } from '../../../../../controller/api/admin'
import ChargeUserFormModal from '../sub-screen/ChargeUserFormModal'
import ChargeUserResetPasswordModal from '../sub-screen/ChargeUserResetPasswordModal'

const TableRow = ({ row, isSuperAdmin, onEdit, onResetPassword, onStatusChange }) => (
  <tr>
    <td>{row.username}</td>
    <td>{row.name || '—'}</td>
    {isSuperAdmin && (
      <td>{row.admin ? (row.admin.name || row.admin.email) : '—'}</td>
    )}
    <td style={{ width: 160 }}>
      {isSuperAdmin ? (
        <Form.Select value={row.status} onChange={(evt) => onStatusChange(evt, row.id)}>
          <option value={0}>Inactive</option>
          <option value={1}>Active</option>
        </Form.Select>
      ) : (
        <span>{row.status === 1 ? 'Active' : 'Inactive'}</span>
      )}
    </td>
    <td>
      <Button variant="outline-primary" size="sm" className="m-1" onClick={() => onEdit(row)}>
        Sửa
      </Button>
      <Button variant="outline-secondary" size="sm" className="m-1" onClick={() => onResetPassword(row)}>
        Đổi MK
      </Button>
    </td>
  </tr>
)

export const ChargeUserTable = ({ isSuperAdmin }) => {
  const [cookies] = useCookies(['lottmekong'])
  const [list, setList] = useState([])
  const [admins, setAdmins] = useState([])
  const [formModal, setFormModal] = useState({ show: false, mode: 'add', chargeUser: null })
  const [resetModal, setResetModal] = useState({ show: false, chargeUser: null })

  const loadChargeUsers = useCallback(async () => {
    const response = await getAllChargeUsers(cookies.lottmekong)
    if (response.error) {
      alert(response.message || 'Không tải được danh sách user nạp tiền')
      return
    }
    setList(response.data || [])
  }, [cookies.lottmekong])

  const loadAdmins = useCallback(async () => {
    if (!isSuperAdmin) return
    const response = await getAllAdmins(cookies.lottmekong)
    if (!response.error) {
      setAdmins(response.data || [])
    }
  }, [cookies.lottmekong, isSuperAdmin])

  useEffect(() => {
    loadChargeUsers()
    loadAdmins()
  }, [loadChargeUsers, loadAdmins])

  const onStatusChange = async (evt, id) => {
    const status = parseInt(evt.target.value, 10)
    if (status === 0 && !window.confirm('Vô hiệu hóa user nạp tiền này?')) {
      loadChargeUsers()
      return
    }
    const resp = await updateChargeUserStatus(cookies.lottmekong, id, status)
    if (resp?.error) {
      alert(resp.message || 'Có lỗi xảy ra')
    }
    loadChargeUsers()
  }

  const handleFormSubmit = async (payload) => {
    if (formModal.mode === 'add') {
      return addChargeUser(cookies.lottmekong, payload)
    }
    return updateChargeUser(cookies.lottmekong, payload)
  }

  const handleFormHide = (reload) => {
    setFormModal({ show: false, mode: 'add', chargeUser: null })
    if (reload) loadChargeUsers()
  }

  const handleResetSubmit = async (id, password) => {
    return resetChargeUserPassword(cookies.lottmekong, id, password)
  }

  const handleResetHide = (reload) => {
    setResetModal({ show: false, chargeUser: null })
    if (reload) loadChargeUsers()
  }

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col>
              <h5>User nạp tiền ({list.length})</h5>
            </Col>
            {isSuperAdmin && (
              <Col className="text-end">
                <Button
                  variant="success"
                  onClick={() => setFormModal({ show: true, mode: 'add', chargeUser: null })}
                >
                  Thêm user
                </Button>
              </Col>
            )}
          </Row>
        </Card.Header>
        <Table responsive className="align-items-center table-flush">
          <thead className="thead-light">
            <tr>
              <th>Username</th>
              <th>Tên hiển thị</th>
              {isSuperAdmin && <th>Admin sở hữu</th>}
              <th>Trạng thái</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 ? (
              <tr>
                <td colSpan={isSuperAdmin ? 5 : 4} className="text-muted">
                  {isSuperAdmin
                    ? 'Chưa có user nạp tiền'
                    : 'Bạn chưa được gán user nạp tiền. Liên hệ superadmin.'}
                </td>
              </tr>
            ) : (
              list.map((row) => (
                <TableRow
                  key={row.id}
                  row={row}
                  isSuperAdmin={isSuperAdmin}
                  onEdit={(chargeUser) => setFormModal({ show: true, mode: 'edit', chargeUser })}
                  onResetPassword={(chargeUser) => setResetModal({ show: true, chargeUser })}
                  onStatusChange={onStatusChange}
                />
              ))
            )}
          </tbody>
        </Table>
      </Card>

      <ChargeUserFormModal
        show={formModal.show}
        mode={formModal.mode}
        chargeUser={formModal.chargeUser}
        isSuperAdmin={isSuperAdmin}
        admins={admins}
        onHide={handleFormHide}
        onSubmit={handleFormSubmit}
      />

      <ChargeUserResetPasswordModal
        show={resetModal.show}
        chargeUser={resetModal.chargeUser}
        onHide={handleResetHide}
        onSubmit={handleResetSubmit}
      />
    </>
  )
}
